import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { Icon, IconWiFiSignal } from '../../../Atoms/Icon';

import Content from './Content';
import styles from './wan.module.css';

const Wifi = ({
  connectionStatus,
  securityDetail,
  ssid,
  signalStrengthNormalized,
  children,
}) => {
  const child = children && children.find((node) => node.key === 'wifi');

  return (
    <Row>
      <Col xs={6} xl={2}>
        <Content
          icon={
            <IconWiFiSignal
              className={classNames('text-primary', styles.iconXl)}
              signalStrength={signalStrengthNormalized}
            />
          }
          line1={connectionStatus || '---'}
          line1ClassName="text-gray-500 text-uppercase"
          line2ClassName={classNames({
            'text-gray-500': !connectionStatus,
          })}
        />
      </Col>

      <Col xs={6} xl={2}>
        <Content
          icon={
            <Icon className={styles.iconMd} name="hierarchy" role="status" />
          }
          line1="SSID"
          line2={ssid || '---'}
          line2ClassName={classNames(ssid ? 'text-blue-dark' : 'text-gray-500')}
        />
      </Col>

      <Col xs={12} xl={2}>
        <Content
          icon={
            <Icon
              className={styles.iconMd}
              name="lock-locked-light"
              role="status"
            />
          }
          line1="Security"
          line2={securityDetail || '---'}
          line2ClassName={classNames(
            'text-uppercase',
            securityDetail ? 'text-blue-dark' : 'text-gray-500',
          )}
        />
      </Col>

      <Col className="col pt-3 pb-5 py-sm-0 text-center text-xl-right">
        {child}
      </Col>
    </Row>
  );
};

Wifi.propTypes = {
  connectionStatus: PropTypes.string,
  securityDetail: PropTypes.string,
  ssid: PropTypes.string,
  signalStrengthNormalized: PropTypes.number,
  children: PropTypes.node,
};

export default Wifi;
